module.exports = __webpack_public_path__ + "img/flash_logo.87360ea5.png";